import React from "react"

function LogoName ({
    fontSize = 18
}) {
    return (
        <span className={`font-arial font-[600] ${fontSize >= 18 ? 'text-base/4' : 'text-base/3'}`}>
            <span className="text-blue-maxx tracking-wide font-[600]">
                <span className={`text-[${fontSize + 2}px]`}>M</span><span className={`relative blue-maxx text-[${(fontSize + 2)- 2}px] font-stretch-extra-expanded z-1`}>AX</span><span className={`text-[${(fontSize + 2) - 2}px] font-stretch-extra-expanded  text-gold ml-[-0.3em]`}>X</span>
            </span>
            <br/>
            <span className={`text-gold tracking-tighter font-[500] items-start`}>
                <span className={`text-gold text-[${fontSize}px]`}>P</span><span className={`text-gold text-[${fontSize - 2}px]`}>ROPERTY</span>
            </span>
        </span>
    )
}

export default LogoName